import React, { useCallback, useRef } from 'react';
import { getAssetPath } from '../utils/paths';

const Process = ({ onShowComingSoon }) => {
  const isProcessing = useRef(false);
  
  const handleClick = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (isProcessing.current) {
      return;
    }
    
    if (onShowComingSoon) {
      isProcessing.current = true;
      onShowComingSoon();
      setTimeout(() => {
        isProcessing.current = false;
      }, 500);
    }
  }, [onShowComingSoon]);

  return (
    <section id="process" className="process pos-rel pb-120">
      <div className="process__shape">
        <div className="shape shape--1" data-parallax='{"x" : 70}'>
          <img src={getAssetPath('/Helax/assets/img/shape/pr_shape1.png')} alt="" />
        </div>
        <div className="shape shape--2">
          <img src={getAssetPath('/Helax/assets/img/shape/pr_shape2.png')} alt="" />
        </div>
        <div className="shape shape--3" data-parallax='{"y" : 80}'>
          <img src={getAssetPath('/Helax/assets/img/shape/pr_shape3.png')} alt="" />
        </div>
      </div>
      <div className="container">
        <div className="crm-title text-center mb-60">
          <h2 className="crm-title__heading">NovaVerse — Trade with Purpose</h2>
        </div>
        <div className="process__wrap ul_li_between">
          <div className="process__title mt-30">
            <h3 className="title">What is Nova Verse</h3>
            <p>NovaVerse is the first DeFi ecosystem built on Solana that transforms every transaction into a direct contribution to the network’s growth.
              Each swap automatically supports the Solana Foundation, meaning every user action strengthens the ecosystem.</p>

            <p> Users can choose their donation rate between 0.3% and 10%, with 0.3% as the mandatory minimum.
              We are building a long-term and continuously sustained contribution model, rather than a one-time system. </p>

            <p>
              NovaVerse continuously identifies and updates wallets that consistently support Solana.
              For ecosystem projects launching in the future, these premium contributor wallets can be offered as a reference list
            </p>

          </div>
          <div className="process__ss mt-30">
            <img src={getAssetPath('/Helax/assets/img/process/logo1.png')} alt="Encrypted inbox" />
          </div>
        </div>
        {/* <div className="row g-38 mt-10">
          <div className="col-lg-5 mt-30">
            <div className="process__app-item">
              <div className="text-center">
                <img src={getAssetPath('/Helax/assets/img/process/img_02.png')} alt="Mobile applications" />
              </div>
              <div className="process__title mt-40">
                <h3 className="title">Mobile applications</h3>
                <p>Prem ipsum dolor sit amet consectetur. Viverra sed dignissim risus aliquet condimentum. Vulputate varius </p>
              </div>
            </div>
          </div>
          <div className="col-lg-7 mt-30">
            <div className="process__app-item style-2">
              <div className="process__title mb-30">
                <h3 className="title">Upload, share, and preview any file</h3>
                <p>Prem ipsum dolor sit amet consectetur. Viverra sed dignissim risus aliquet condimentum. Vulputate varius </p>
              </div>
              <div className="text-center">
                <img src={getAssetPath('/Helax/assets/img/process/img_03.png')} alt="File upload" />
              </div>
            </div>
          </div>
        </div>
        <div className="process__button mt-60">
          <div className="btns text-center">
            <a className="thm-btn thm-btn--gradient style-2" href="#!">Get Started Today</a>
            <a className="thm-btn thm-btn--outline style-2" href="#!">Browse all Features</a>
          </div>
        </div> */}
        <div className="row pt-150 pt-xs-90">
          <div className="col-12">
            <div className="process__area">
              <div className="process__top ul_li_between mt-none-30">
                <div className="crm-title mt-30">
                  <h2 className="crm-title__heading mb-15">All data is transparent, reliable, and under the user's control</h2>
                  <p>Read the document to see how the system works and learn more details </p>
                  <div className="mt-40">
                    <a className="thm-btn thm-btn--gradient style-2" href="#!" onClick={handleClick}>Browse all feature</a>
                  </div>
                </div>
                <div className="image mt-30">
                  <img src={getAssetPath('/Helax/assets/img/process/nova2.png')} alt="Transparent" />
                </div>
              </div>
              {/* <div className="row g-26 mt-10">
                <div className="col-lg-6 mt-30">
                  <div className="process__app-item style-3">
                    <div className="process__title process__title--lg mb-30">
                      <h3 className="title">Product Mail</h3>
                      <p>Gonsectetur eque nec nunc facilisis tellus tincidunt. <br /> Malesuada maecenas ac bibendum consectetur.</p>
                    </div>
                    <div className="text-center">
                      <img src={getAssetPath('/Helax/assets/img/process/img_05.png')} alt="Product Mail" />
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 mt-30">
                  <div className="process__app-item style-3">
                    <div className="process__title process__title--lg mb-30">
                      <h3 className="title">Product UI</h3>
                      <p>Honsectetur eque nec nunc facilisis tellus tincidunt. <br /> Malesuada maecenas ac bibendum consectetur.</p>
                    </div>
                    <div className="text-center">
                      <img src={getAssetPath('/Helax/assets/img/process/img_06.png')} alt="Product UI" />
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;

